import {
    createdNewFolder,
    creatingNewFolder,
    creatingNewFolderFailed,
    openFolderSelector,
    userEnteringNewFolderName,
} from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(openFolderSelector, () => {
    // We need to reset the create folder state when the modal opens
    getStore().createFolderViewState = {
        isCreating: false,
        isUserEnteringText: false,
    };
});

mutator(creatingNewFolder, actionMessage => {
    const { folderName } = actionMessage;
    getStore().createFolderViewState = {
        folderName: folderName,
        isCreating: true,
    };
});

mutator(createdNewFolder, () => {
    getStore().createFolderViewState = {
        isCreating: false,
        isUserEnteringText: false,
    };
});

mutator(creatingNewFolderFailed, () => {
    getStore().createFolderViewState = {
        isCreating: false,
        isUserEnteringText: false,
    };
});

mutator(userEnteringNewFolderName, actionMessage => {
    const { isUserEnteringNewFolderName } = actionMessage;
    const store = getStore();

    if (store.createFolderViewState.isCreating === false) {
        store.createFolderViewState.isUserEnteringText = isUserEnteringNewFolderName;
    }
});
